module.exports = __webpack_public_path__ + "media/images/emblems/Oberthal-coat_of_arms-6a4ee63283ee0e544218c009ff8ace97.svg";